module.exports = __webpack_public_path__ + "img/cover1.66efcc1e.png";